<template>
  <lazy-div :load="doInit">
    <v-layout row wrap>
      <v-flex xs12>
        <v-card>
          <v-card-title>
            <v-text-field append-icon="mdi-magnify" label="Search" single-line hide-details v-model="search"></v-text-field>
            <v-spacer></v-spacer>
            <v-btn color="primary" dark class=" mr-2" @click="doNew">New Clause<v-icon>mdi-plus</v-icon></v-btn>
            <!-- <v-flex xs4>
              <v-layout row>
                <v-spacer></v-spacer>
                <v-menu offset-x :nudge-left="370" :close-on-content-click="false" :min-width="300" :max-height="400">
                  <v-btn color="secondary" class="white--text" v-on="on">
                    <span>Columns</span>
                    <v-icon right dark>mdi-table-column-plus-after</v-icon>
                  </v-btn>
                  <v-card>
                    <v-card-text>
                      <template v-if="columns.length > 0">
                        <v-checkbox v-for="column in columns" :key="column.value" :label="column.text" :value="column.value" v-model="selectedColumns"></v-checkbox>
                      </template>
                      <template v-else>
                        No column found
                      </template>
                    </v-card-text>
                  </v-card>
                </v-menu>
              </v-layout>
            </v-flex> -->
          </v-card-title>
          <v-flex xs12>
            <message :messages="messages"></message>
          </v-flex>
          <v-data-table
            :headers="headers"
            :items="filteredItems"
            :search="search"
            :footer-props="{'items-per-page-options': itemsPerPage }"
            v-bind:options.sync="pagination"
            item-key="name"
            :loading="loading"
            :no-data-text="noDataText"
            :custom-filter="customSearch"
          >
            <template v-slot:item="row"
              ><tr>
                <td class="text-xs-left">{{ row.item.busCls }}</td>
                <td class="text-xs-left">{{ row.item.busClsDesc }}</td>
                <td class="text-xs-left">{{ row.item.clseNo }}</td>
                <td class="text-xs-left">{{ row.item.clseTitle }}</td>
                <td class="text-xs-left">{{ row.item.defClse }}</td>
                <td class="table-action-header">
                  <table-action
                    :rowData="row"
                    review
                    @review="doReview"
                    remove
                    @remove="doPromptRemove(row.item)"
                    query
                    @query="doQuery"
                  ></table-action>
                </td></tr
            ></template>
          </v-data-table>
          <confirm v-model="promptRemove" @ok="doRemove"> Are you sure that you want to delete the selected Clause? {{ deleteBusClsClse }} </confirm>
        </v-card>
      </v-flex>
    </v-layout>
  </lazy-div>
</template>

<script>
import { mapGetters } from 'vuex'
import { expandURI } from '@/utils/ajax'
import MessageMixin from '@/mixins/message'
import { listMixin } from '@/components/reusable/listMixins'
import * as TableConst from '@/mixins/table'

export default {
  data() {
    return {
      headers: [
        { text: 'Business Class', align: 'left', value: 'busCls' },
        { text: 'Business Class Description', align: 'left', value: 'busClsDesc' },
        { text: 'Clause No.', align: 'left', value: 'clseNo' },
        { text: 'Clause No. Title', align: 'left', value: 'clseTitle' },
        { text: 'Default Clause', align: 'left', value: 'defClse' },
        TableConst.tableActionHeader
      ],
      promptRemove: false,
      selectedBusClsClse: undefined,
      deleteBusClsClse: '',
      pagination: {
        sortDesc: [false],
        page: 1
      }
    }
  },
  watch: {
    fetchBusClsClse: function (value) {
      if (value !== false) {
        this.doInit()
      }
    }
  },
  computed: {
    ...mapGetters(['checkAccess']),
    clsemenu() {
      return this.$store.state.docFormatParam.menu
    },
    filteredItems() {
      return this.items.filter((item) => {
        return !this.search || item.busCls.toLowerCase().includes(this.search.toLowerCase())
      })
    }
  },
  methods: {
    async doInit() {
      this.loading = true
      const apiURI = this.clsemenu.busClsClseList
      if (apiURI) {
        try {
          const expand = {
            clseNo: this.clseNo
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          const { data } = result.data
          if (data) {
            this.items = []
            data.map((busClsClse) => {
              const convertBusClsClse = {
                // branch: busClsClse.branch,
                busCls: busClsClse.busCls,
                busClsDesc: busClsClse.busClsDesc,
                clseNo: busClsClse.clseNo,
                clseTitle: busClsClse.clseTitle,
                defClse: this.formatBoolean(busClsClse.defClse)
              }
              this.items.push(convertBusClsClse)
            })
            this.loading = false
          } else {
            this.loading = false
            this.items = []
          }
        } catch (error) {
          const { data } = error
          if (data) {
            this.message(data)
            this.fieldMessage(data)
            this.loading = false
          }
        }
      } else {
        this.loading = false
      }
    },
    doQuery(data) {
      this.$emit('doQuery', data.item)
    },
    doReview(data) {
      this.$emit('doReview', data.item)
    },
    doNew() {
      this.$emit('doNew')
    },
    doPromptRemove(data) {
      this.resetMessages()
      if (data) {
        const apiURI = this.clsemenu.checkDeleteBusClsClse
        if (apiURI) {
          const expand = {
            clseNo: data.clseNo,
            busCls: data.busCls
            // branch: data.branch
          }
          this.$http
            .get(expandURI(apiURI, expand))
            .then((result) => {
              this.selectedBusClsClse = data
              this.promptRemove = true
            })
            .catch((err) => {
              const { data } = err.response
              if (data) {
                this.fieldMessage(data)
                this.notify(data)
              }
            })
        }
      }
    },
    async doRemove() {
      if (this.selectedBusClsClse.clseNo) {
        const apiURI = this.clsemenu.deleteBusClsClse
        if (apiURI) {
          const expand = {
            clseNo: this.selectedBusClsClse.clseNo,
            busCls: this.selectedBusClsClse.busCls
            // branch: this.selectedBusClsClse.branch
          }
          this.$http
            .delete(expandURI(apiURI, expand))
            .then((result) => {
              const data = result.data
              this.notify(data)
              this.promptRemove = false
              this.doInit()
            })
            .catch((err) => {
              this.promptRemove = false
              const { data } = err.response
              if (data) {
                this.message(data)
              }
            })
        }
      }
    }
  },
  props: {
    fetchBusClsClse: {
      type: Boolean,
      default: false
    },
    clseNo: {
      type: String,
      default: ''
    },
    clseTitle: {
      type: String,
      default: ''
    }
  },
  mixins: [listMixin, MessageMixin]
}
</script>

<style>
</style>
